export default ($axios) => ({
  fetchPlans(query) {
    return $axios.get('/plans', { params: query }).then((response) => response.data);
  },
  fetchPlan(planId) {
    return $axios.get(`/plans/${planId}`).then((response) => response.data);
  },
});
